import React from 'react';
import PropTypes from 'prop-types';

class DownloadEmailButton extends React.PureComponent {
  constructor() {
    super();
    this.onClickHelper = this.onClickHelper.bind(this);
    this.exportPdfTopBarOnClick = this.exportPdfTopBarOnClick.bind(this);
    this.emailRecepientPdfTopBarOnClick = this.emailRecepientPdfTopBarOnClick.bind(this);
    this.openSignatureReminderModal = this.openSignatureReminderModal.bind(this);
    this.liOnClickHelper = (e, timer = 1500) => {
      if (e) {
        e.preventDefault();
      }
      window.ReactCompatibility.saveFreeWriteContent();
      setTimeout(
        () => {
          document.location.href = window.ExportDocument.newAccountPath + document.location.search;
        }, timer);
    };

    this.linkCreationHelper = (key, onclick, className, text) => (
      <a
        href=""
        key={key}
        onClick={onclick}
        className={className}
      >
        {text}
      </a>
    );
  }

  componentWillReceiveProps(nextProps) {
    const { continueAndExport } = nextProps;
    if (continueAndExport) {
      this.exportPdfTopBarOnClick(null, 500);
    }
  }

  onClickHelper(e, timer = 1500, category, action) {
    if (this.props.disabled) {
      return false;
    }
    if (window.COOKIE.get('userid')) {
      window._track(category, action);
    }
    this.liOnClickHelper(e, timer);
    return false;
  }

  openSignatureReminderModal(e) {
    if (this.props.disabled) {
      return false;
    }
    const noUser = !window.COOKIE.get('userid');
    const noSigAdded = !window.localStorage.getItem('signatureAdded');
    // if user is not logged in and has not placed a signature on any document
    if (noUser && noSigAdded) {
      window.ReactCompatibility.openFreeWriteSignatureReminderModal();
      e.preventDefault();
    } else {
      this.exportPdfTopBarOnClick(e);
    }
    return false;
  }

  exportPdfTopBarOnClick(e, timer = 1500) {
    this.onClickHelper(e, timer, 'Export | pdf_topbar', `${this.props.documentType} | FreeWrite-Builder${this.props.memberTracking}`);
  }

  emailRecepientPdfTopBarOnClick(e) {
    this.onClickHelper(e, 'E-Mail to Recipient | pdf_topbar', `${this.props.documentType} | FreeWrite-Builder${this.props.memberTracking}`);
  }

  render() {
    let downloadEmailGroup;
    if (this.props.showConvertDoc) {
      downloadEmailGroup = (
        <div className="btn-group">
          <button
            id="convert_tool"
            onClick={this.liOnClickHelper}
            className="btn btn-success"
          >
            Convert to Word Document
          </button>
        </div>
      );
    } else {
      downloadEmailGroup = (
        <div className="btn-group">
          {this.linkCreationHelper('download-pdf-a', this.openSignatureReminderModal,
          'btn btn-success non-member-toolbar-cta', ' Download PDF')}
          {this.linkCreationHelper('email-recepient-a', this.emailRecepientPdfTopBarOnClick,
          'btn btn-success non-member-toolbar-cta', 'E-Mail to Recipient')
          }
        </div>
      );
    }

    return downloadEmailGroup;
  }
}

DownloadEmailButton.defaultProps = {
  documentType: '',
  showConvertDoc: false,
  memberTracking: '',
  disabled: false,
  continueAndExport: false,
};

DownloadEmailButton.propTypes = {
  documentType: PropTypes.string,
  showConvertDoc: PropTypes.bool,
  memberTracking: PropTypes.string,
  disabled: PropTypes.bool,
  continueAndExport: PropTypes.bool,
};

export default DownloadEmailButton;



// WEBPACK FOOTER //
// ./src-react/ExportToolbar/DownloadEmailButton.jsx